<template>
  <div>
    <div class="py-5 overflow-auto max-h-[70vh]">
      <div>
        <div class="flex align-center border border-blue-200 bg-white dark-bg-custom">
          <span v-tooltip="{ text: infoMessage }">
            <v-icon class="ml-4">mdi-information</v-icon>
          </span>
          <div class="w-full">
            <v-combobox
              v-model="meetingOptions"
              :items="comboBoxOptions"
              hide-selected
              hint="type and hit enter"
              :label="label"
              persistent-hint
              multiple
              small-chips
              class="mx-4"
              @input="emitComboBoxData"
            >
              <template v-slot:selection="{ item }">
                <v-chip @click="removeChip(item, meetingOptions)">
                  {{ item }}
                  <v-icon small class="ml-2">mdi-close-circle</v-icon>
                </v-chip>
              </template>
            </v-combobox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      meetingOptions: []
    }
  },
  props: {
    receivedData: {
      type: Object,
      default: null
    },
    heading: String,
    infoMessage: String,
    comboBoxOptions: Array,
    label: String
  },
  watch: {
    comboBoxOptions(newVal) {
      if (newVal !== null) this.meetingOptions = newVal
    }
  },
  methods: {
    removeChip(item, options) {
      const index = options.indexOf(item)
      if (index !== -1) {
        options.splice(index, 1)
      }
      this.emitComboBoxData()
    },
    emitComboBoxData() {
      const obj = {
        title: this.heading.toUpperCase().split(' ').join('_'),
        value: this.meetingOptions
      }
      this.$emit('comboBoxValue', obj)
    }
  },
  mounted() {
    this.meetingOptions = this.$props.comboBoxOptions || []
  }
}
</script>
<style scoped>
/* Added scoped styles for consistent tooltip alignment */
.ml-4 {
  margin-left: 1rem;
}
</style>
